import * as React from "react";
import { Link } from "react-router-dom";
import { FOOTER_COLUMNS } from "../lib/nav-links.js";

/**
 * Fat footer used by Landing + Catalog (and any other Field Day page). All link
 * targets stay inside the SPA — no third-party destinations.
 *
 * The deep-link columns (FOOTER_COLUMNS) are the site's main crawl spine into
 * the grade hubs and per-test pages: rendered on every page, they give those
 * deep pages a site-wide inbound link they otherwise lacked (the footer grid CSS
 * predates this — only the legal row was being rendered). The bottom row keeps
 * the copyright + legal links.
 */
export function FieldFooter(): React.ReactElement {
  return (
    <footer className="v-field__footer">
      <div className="container">
        <div className="v-field__footer-grid">
          <div>
            <Link to="/" className="v-field__footer-brand">
              Sports Academy Games
            </Link>
            <p className="v-field__footer-blurb">
              K–12 math practice turned into fast, head-to-head video games. Free to start — no
              sign-up needed.
            </p>
          </div>
          {FOOTER_COLUMNS.map((col) => (
            <div key={col.title}>
              <h4>{col.title}</h4>
              <ul>
                {col.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to}>{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="v-field__footer-bot">
          <span>© {new Date().getFullYear()} Sports Academy Games. All rights reserved.</span>
          <div className="v-field__footer-legal">
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
            <Link to="/about">About</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
